import i18n from "@/i18n";
import globalMethods from "@/globalMethods";
import {URLS, ROLES} from "@/constants";
import {notify} from "@/plugins/notification";


export default {
    namespaced: true,
    state: {
        cashRegisters: [],
        cashRegisterData: null,
    },
    mutations: {
        setCashRegisters(state, data) {
            state.cashRegisters = data;
        },
        setCashRegisterData(state, newCashRegisterData) {
            state.cashRegisterData = newCashRegisterData;
        },
        addCashRegister(state, newCashRegister) {
            state.cashRegisters.unshift(newCashRegister);
        },
        updateCashRegister(state, params) {
            const {cashRegisterId, data} = params;
            const cashRegisterIndex = state.cashRegisters.findIndex(cashRegister => cashRegister.id === cashRegisterId);
            if (cashRegisterIndex === -1) {
                console.error("Error at the updateCashRegister mutation!");
                return;
            }
            state.cashRegisters[cashRegisterIndex] = {
                ...state.cashRegisters[cashRegisterIndex],
                ...data
            };
        },
        deleteCashRegister(state, cashRegisterId) {
            state.cashRegisters = state.cashRegisters.filter(cashRegister => cashRegister.id !== cashRegisterId);
        },
        increaseTotalAvailableBalance(state, newTransactionData) {
            const currentCashRegisterId = state.cashRegisters.findIndex(cashRegister => cashRegister.id === state.cashRegisterData.id);
            if (newTransactionData["transfer_to"]) {
                state.cashRegisterData["balances"][newTransactionData["currency"]][newTransactionData["payment_method_from"]] = Math.round((state.cashRegisterData["balances"][newTransactionData["currency"]][newTransactionData["payment_method_from"]] - Number(newTransactionData["total"])) * 100) / 100;
                state.cashRegisters[currentCashRegisterId]["balances"][newTransactionData["currency"]][newTransactionData["payment_method_from"]] = Math.round((state.cashRegisters[currentCashRegisterId]["balances"][newTransactionData["currency"]][newTransactionData["payment_method_from"]] - Number(newTransactionData["total"])) * 100) / 100;
                if (newTransactionData["shop_id"] === newTransactionData["transfer_to"]["id"]) {
                    state.cashRegisterData["balances"][newTransactionData["currency"]][newTransactionData["payment_method_to"]] = Math.round((state.cashRegisterData["balances"][newTransactionData["currency"]][newTransactionData["payment_method_to"]] + Number(newTransactionData["total"])) * 100) / 100;
                    state.cashRegisters[currentCashRegisterId]["balances"][newTransactionData["currency"]][newTransactionData["payment_method_to"]] = Math.round((state.cashRegisters[currentCashRegisterId]["balances"][newTransactionData["currency"]][newTransactionData["payment_method_to"]] + Number(newTransactionData["total"])) * 100) / 100;
                }
            } else {
                state.cashRegisterData["balances"][newTransactionData["currency"]][newTransactionData["payment"]] = Math.round((state.cashRegisterData["balances"][newTransactionData["currency"]][newTransactionData["payment"]] + Number(newTransactionData["total"])) * 100) / 100;
                state.cashRegisters[currentCashRegisterId]["balances"][newTransactionData["currency"]][newTransactionData["payment"]] = Math.round((state.cashRegisters[currentCashRegisterId]["balances"][newTransactionData["currency"]][newTransactionData["payment"]] + Number(newTransactionData["total"])) * 100) / 100;
            }
        },
        decreaseTotalAvailableBalance(state, newTransactionData) {
            const currentCashRegisterId = state.cashRegisters.findIndex(cashRegister => cashRegister.id === state.cashRegisterData.id);
            state.cashRegisterData["balances"][newTransactionData["currency"]][newTransactionData["payment"]] = Math.round((state.cashRegisterData["balances"][newTransactionData["currency"]][newTransactionData["payment"]] - Number(newTransactionData["total"])) * 100) / 100;
            state.cashRegisters[currentCashRegisterId]["balances"][newTransactionData["currency"]][newTransactionData["payment"]] = Math.round((state.cashRegisters[currentCashRegisterId]["balances"][newTransactionData["currency"]][newTransactionData["payment"]] - Number(newTransactionData["total"])) * 100) / 100;
        },
    },
    actions: {
        async getCashRegisters({ commit, rootState }) {
            const {personalData, company} = rootState;
            const url = URLS.MODEL.SHOP.SHOPS_URL;
            const options = {
                method: "GET",
                headers: {
                    role: personalData.role,
                    companyId: company.companyData?.token,
                },
                credentials: 'include',
            };
            const successfulHandler = (data) => {
                commit("setCashRegisters", data.data);
                return {successfully: true};
            };
            return globalMethods.sendRequestToGetJson({url: url, options: options, successfulHandler: successfulHandler});
        },
        async getCashRegisterData({ commit, rootState }) {
            const {personalData, company} = rootState;
            if (personalData.role === ROLES.STAFF && company.companyData?.token === null) {
                return {successfully: false, detail: "redirect_to_choose_role"};
            }

            const url = URLS.MODEL.SHOP.SHOP_URL.replace("<ID>", globalMethods.getDataFromLocalStorage("currentCashRegisterId"));
            const options = {
                method: "GET",
                headers: {
                    role: personalData.role,
                    companyId: company.companyData?.token,
                },
                credentials: 'include',
            };
            const successfulHandler = (data) => {
                commit("setCashRegisterData", data.data);
                return {successfully: true};
            };
            return globalMethods.sendRequestToGetJson({url: url, options: options, successfulHandler: successfulHandler});
        },
        async createCashRegister({ commit, rootState }, params) {
            const {personalData, company} = rootState;
            const {name, address, city, timezone, payment_methods, payment_method_order, default_currency, default_payment, reference, selectedGoods, default_day_shift_start, default_day_shift_end, default_night_shift_start, default_night_shift_end, contact_phone, contact_whatsapp, contact_telegram, contact_max} = params;
            const url = URLS.MODEL.SHOP.SHOPS_URL;
            const options = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": globalMethods.getCookie("csrftoken"),
                    role: personalData.role,
                    companyId: company.companyData?.token,
                },
                body: JSON.stringify({
                    name: name,
                    address: address,
                    timezone: timezone,
                    city: city,
                    payment_methods: payment_methods,
                    payment_method_order: payment_method_order,
                    default_payment: default_payment,
                    default_currency: default_currency,
                    reference: reference,
                    default_day_shift_start: default_day_shift_start,
                    default_day_shift_end: default_day_shift_end,
                    default_night_shift_start: default_night_shift_start,
                    default_night_shift_end: default_night_shift_end,
                    contact_phone: contact_phone || "",
                    contact_whatsapp: contact_whatsapp || "",
                    contact_telegram: contact_telegram || "",
                    contact_max: contact_max || "",
                    good_ids: selectedGoods,
                }),
                credentials: 'include',
            };
            const successfulHandler = (data) => {
                commit("addCashRegister", data.data);
                commit("good/addCashRegisterToGoods", {newCashRegister: data.data, goodIds: selectedGoods}, {root: true});
                notify(i18n.global.t("The cash register has been successfully added"));
                return {successfully: true};
            };
            return globalMethods.sendRequestToGetJson({url: url, options: options, successfulHandler: successfulHandler});
        },
        async updateCashRegister({ commit, state, rootState }, params) {
            const {personalData, company} = rootState;
            const {cashRegisterId, name, address, payment_methods, payment_method_order, default_currency, default_payment, reference, default_day_shift_start, default_day_shift_end, default_night_shift_start, default_night_shift_end, contact_phone, contact_whatsapp, contact_telegram, contact_max} = params;
            const url = URLS.MODEL.SHOP.SHOP_URL.replace("<ID>", cashRegisterId);
            const options = {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": globalMethods.getCookie("csrftoken"),
                    companyId: company.companyData?.token,
                    timezone: state.cashRegisterData?.timezone,
                    role: personalData.role,
                },
                body: JSON.stringify({
                    name: name,
                    address: address,
                    payment_methods: payment_methods,
                    payment_method_order: payment_method_order,
                    default_currency: default_currency,
                    default_payment: default_payment,
                    reference: reference,
                    default_day_shift_start: default_day_shift_start,
                    default_day_shift_end: default_day_shift_end,
                    default_night_shift_start: default_night_shift_start,
                    default_night_shift_end: default_night_shift_end,
                    contact_phone: contact_phone || "",
                    contact_whatsapp: contact_whatsapp || "",
                    contact_telegram: contact_telegram || "",
                    contact_max: contact_max || "",
                }),
                credentials: 'include',
            };
            const successfulHandler = (data) => {
                commit("updateCashRegister", {cashRegisterId: cashRegisterId, data: data.data});
                notify(i18n.global.t("The cash register data has been successfully updated"));
                return {successfully: true};
            };
            return globalMethods.sendRequestToGetJson({url: url, options: options, successfulHandler: successfulHandler});
        },
        async deleteCashRegister({ commit, rootState }, data) {
            const {personalData, company} = rootState;
            const {cashRegisterId, mode} = data;
            const url = URLS.MODEL.SHOP.SHOP_URL.replace("<ID>", cashRegisterId);
            const options = {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": globalMethods.getCookie("csrftoken"),
                    role: personalData.role,
                    companyId: company.companyData?.token,
                },
                credentials: 'include',
                body: JSON.stringify({
                    mode: mode
                }),
            };
            const successfulHandler = () => {
                commit("deleteCashRegister", cashRegisterId);
                notify(i18n.global.t("The cash register has been successfully deleted"));
                return {successfully: true};
            };
            return globalMethods.sendRequestToGetJson({url: url, options: options, successfulHandler: successfulHandler});
        },
        async updateCashRegisterOrder({ commit, rootState }, data) {
            const {target_shop_id, to_shop_id, mode} = data;
            const {personalData, company} = rootState;
            const url = URLS.MODEL.SHOP.SHOPS_URL;
            const options = {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": globalMethods.getCookie("csrftoken"),
                    role: personalData.role,
                    companyId: company.companyData?.token,
                },
                credentials: "include",
                body: JSON.stringify({
                    target_shop_id: target_shop_id,
                    to_shop_id: to_shop_id,
                    mode: mode
                }),
            };
            const successfulHandler = (data) => {
                commit("setCashRegisters", data.data);
                notify(i18n.global.t("The order of the cash registers has been successfully updated"));
                return {successfully: true};
            };
            return globalMethods.sendRequestToGetJson({url: url, options: options, successfulHandler: successfulHandler});
        },
    },
};